// @flow
import { useEffect, useRef } from 'react';

import { Search } from 'lucide-react';
import { TextField } from 'reshaped';
import type { ChangeHandler } from 'reshaped';

import { useTranslator } from '@gandi/translate';

type Props = {
  onChange: ChangeHandler<string>,
  value: string,
};

export function SearchField({
  onChange,
  value,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const inputRef = useRef<?HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    // $FlowFixMe[incompatible-type]
    <TextField
      icon={<Search />}
      name="search"
      size="medium"
      variant="faded"
      placeholder={__('Search')}
      value={value}
      onChange={onChange}
      inputAttributes={{ ref: inputRef }}
    />
  );
}
